import { Constants } from '../../common/Constants';
import { useCurrentMember } from '../useCurrentMember';
import { useLagoon } from '../useLagoon';

export const useCustomDisclaimerMessage = (key: string) => {
  const currentMember = useCurrentMember();
  const customDisclaimerData = useLagoon('custom-disclaimers')();

  const policyDisclaimer = customDisclaimerData?.find(
    (data) =>
      data?.dnt_pageName === key &&
      data?.active &&
      data?.policyId
        ?.split(',')
        ?.map((id) => id.trim())
        ?.includes(currentMember?.policyNumber)
  )?.message;

  const clientName = sessionStorage.getItem(
    Constants.STORAGE_KEYS.SESSION.CLIENT_NAME
  );

  const clientNameDisclaimer = customDisclaimerData?.find(
    (data) =>
      data?.dnt_pageName === key &&
      data?.active &&
      data?.clientName?.toLowerCase() === clientName?.toLowerCase()
  )?.message;

  return policyDisclaimer ?? clientNameDisclaimer;
};
